module.exports = __webpack_public_path__ + "static/briviact-logo-6c36197713880e32b8660559dc20a08d.png";